export default __webpack_public_path__ + "696ca5cc592ffb23eb3daabf56363e85.jpg";